import React from "react";
import Icon, { IconProps } from "./Icon";

/**
 * Company icon for representing businesses and organizations
 */
export const CompanyIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
      <line x1="4" y1="10" x2="20" y2="10"></line>
      <line x1="10" y1="4" x2="10" y2="20"></line>
    </Icon>
  );
};

export default CompanyIcon;
